import React from 'react';

export function SvgIcon({
    children,
    viewBox = '0 0 32 32',
    width = '1em',
    height = '1em',
    fontSize = 'inherit',
    ...rest
}: React.SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox={viewBox} width={width} height={height} fontSize={fontSize} {...rest}>
            {children}
        </svg>
    );
}
